module.exports = __webpack_public_path__ + "static/media/hall-P5.a32505e7.svg";